import React, { useState } from 'react';
import { Container, Table, Row, Col } from 'react-bootstrap';
import NavigationBar from '../../ReusableComp/NavigationBar';
import { tableData } from '../../ReusableComp/UserManuals';
import { base_url } from '../../../utilities';
import Loader from '../../ReusableComp/Loader';

const PMSAdminUserManual = () => {
  
  const [searchText, setSearchText] = useState("");
  const [filteredTableData, setFilteredTableData] = useState(null);
  const [userUrl,setUserUrl]=useState();
  const [loading,setLoadingg]=useState(false);
  let   [loading_flag, Setloading_flag] = useState(false);

  const rowsToRender = searchText ? filteredTableData : tableData;
  

  const handleSearchData = (event) => {
    const searchText = event.target.value?.toLowerCase();
    setSearchText(searchText);
    const filteredData = tableData?.filter((item) => {
      const { user_Persona , user_Manual} = item;

      const formattedUserPersona = user_Persona?.toLowerCase();
      const formattedUserManual = user_Manual ? user_Manual.toLowerCase() : ""

      return (
        formattedUserPersona.includes(searchText) ||
        formattedUserManual.includes(searchText)
      );
    });

    setFilteredTableData(filteredData);
  };



  const fetchImages = async (document_url) => {
    if (document_url != null && document_url !== '') {
    setLoadingg(true)
      const queryParams = `?url=${document_url}`;
      const response = await fetch(base_url + 'api/getImage' + queryParams);
      const data = await response.arrayBuffer();
      const base64 = btoa(new Uint8Array(data).reduce((data, byte) => data + String.fromCharCode(byte), ''));
      //document_url = `data:${response.headers.get('content-type')};base64,${base64}`;
      // return document_url;
      setUserUrl(`data:${response.headers.get('content-type')};base64,${base64}`)
      setLoadingg(false)
      return `data:${response.headers.get('content-type')};base64,${base64}`
    }
};

  const downloadFile = async (document_url, typeOfDoc, user_Manual) => {
    // Fetch images from the document_url (not provided in the code snippet)
    const user_Url = await fetchImages(document_url);
    // await new Promise(resolve => setTimeout(resolve, 3000));
    // Check if ciomsUrl is defined or not
    if (user_Url) {
      // Define valid document types (in this case, only "pdf" is considered valid)
      const validDocumentTypes = ["pdf"];
      // Check if the specified document type is valid
      if (validDocumentTypes.includes(typeOfDoc)) {
        try {
          // Fetch the file from ciomsUrl
          const response = await fetch(user_Url);
          if (!response.ok) {
            throw new Error(`Failed to fetch file. HTTP status: ${response.status}`);
          }
          // Convert the response to a blob
          const blob = await response.blob();
          // Create a Blob from the binary data
          const blobUrl = window.URL.createObjectURL(blob);
          // Create a download link and trigger a click event
          const downloadLink = document.createElement('a');
          downloadLink.href = blobUrl;
          downloadLink.download = user_Manual; // Set the desired file name
          // Append the download link to the document body
          document.body.appendChild(downloadLink);
          // Trigger a click event
          downloadLink.click();
          // Remove the download link from the document body
          document.body.removeChild(downloadLink);
          // Clean up the URL.createObjectURL
          window.URL.revokeObjectURL(blobUrl);
        } catch (error) {
          console.error('Error fetching or downloading file:', error);
        }
      }
    }
  };

  return (
    <div>
      <NavigationBar studyDropdwn={true} title={"User Manuals"} />
      <div className='main_body' style={{marginTop:"100px"}}>

      <Container fluid className="pitable_container mt-2"> 
        <Row className='searchbar'>
        <Col className='searchFiled gap-3'>
            <label htmlFor="" />
            <input type="text" value={searchText} style={{ width: "400px" }} placeholder='Search with User Persona and User Manuals' onChange={handleSearchData} />
            <div className=" ">
         
            </div>
          </Col>
        </Row>
     

                     
      

      {loading_flag ? (
        <div className=''>
          {/* Your loading indicator */}
          <img
            className="atrium_loader"
            src="/images/circle-effect-loading.gif"
            alt="Loader"
          />
        </div>
      ) : (
        <div className='table-scroll-container' style={{ border: "1px solid #E1E5E7 ",}}>
          <Table bordered size="sm" className='pitable mb-0'>
            <thead className='sticky_table_header'>
              <tr>
                <th>S.NO</th>
                <th>User persona</th>
                <th>User Manuals</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {rowsToRender.map((row,index) => (
                  <tr key={index + 1} className='text_center_table'>
                  <td>{row["S.no"]}</td>
                  <td>{row["user_Persona"]}</td>
                  <td>{row["user_Manual"]}</td>
                  <td className='d-flex justify-content-center align-items-center'>
                    <img
                      height="30px"
                      width="40px"
                      src='./images/icons/reshot-icon-pdf.svg'
                      title='Click on the icon to download the file'
                      style={{ cursor: "pointer"}}
                      onClick={() => {downloadFile(row?.user_Url,'pdf',row?.user_Manual)}}
                      
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
        
      )}
       </Container>
    </div>
    {loading && <Loader />}
    </div>
  );
};

export default PMSAdminUserManual;




